// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "calendar" + "." + "d4d5e6cad8f4b81d2ad1" + ".css";
};